import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 500px;
  padding: 20px;
  border: 1px solid grey;
  box-shadow: 0 0 8px black;
  margin: 0 auto;
  margin-top: 100px;
`;

export const InputWrapper = styled.div`
  margin-bottom: 20px;
`;

export const InputUpperWrapper = styled.div`
  display: flex !important;
  flex-direction: column !important;
`;

export const LoginContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2.25rem;
  text-align: center;
  padding: 20px;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 0;
  }

  /* Ensure all child elements are above the overlay */
  > * {
    position: relative;
    z-index: 1;
  }
`;

export const LoginHeader = styled.header`
  margin-bottom: 0px;
`;

export const TelusLogo = styled.img`
  max-width: 150px;
  margin-bottom: 10px;
`;

export const Title = styled.h1`
  font-size: 1.8rem;
  color: rgb(75, 40, 109);
  margin: 0;
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #71757b;
  margin-top: 10px;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  max-width: 425px;
  padding: 2rem;
  width: 100%;
  border: 1px solid #71757b;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const LoginCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  padding: 32px;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
  background: #ffffff;
  text-align: center;
`;

export const CardTitle = styled.h2`
  font-size: 1.5rem;
  color: rgb(75, 40, 109);
  margin-bottom: 10px;
`;

export const CardDescription = styled.p`
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 20px;
  line-height: 1.4;
`;

export const LoginButton = styled.button`
  display: inline-block;
  width: 350px;
  padding: 12px;
  border: none;
  border-radius: 5px;
  font-size: 1.15rem;
  background-color: #2b8000;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #1f5c09;
  }
`;

export const LoginButtonSecondary = styled.button`
  display: inline-block;
  width: 350px;
  padding: 12px;
  border: none;
  border-radius: 5px;
  font-size: 1.15rem;
  background-color: #4b286d;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgb(56, 29, 83);
  }
`;

export const RegisterSection = styled.div`
  margin-top: 20px;
  font-size: 1rem;
  color: #555;
`;

export const RegisterLink = styled.a`
  color: rgb(43, 128, 0);
  text-decoration: none;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

export const SeparatorMain = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 400px;
`;

export const SeparatorText = styled.span`
  position: relative;
  width: 340px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #71757b;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 150px;
    height: 1px;
    top: 24px;
    background-color: #71757b;
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
  width: 100%;
  align-items: center;
`;

export const LinkContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
`;

export const LinkText = styled.div`
  color: #71757b;
`;

export const LinkUrl = styled.p`
  color: #2b8000;

  &:hover {
    text-decoration: underline;
    color: rgb(42, 103, 12);
  }
`;
